import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import CheckApiRequests from 'shared/utils/CheckApiRequests';
import { PagePath } from 'shared/constants/pagePath';
import { PaymentCallback } from 'plantItemNew/pages/paymentCallback/PaymentCallback';
import { hotjar } from 'shared/utils/hotjar';
import ReactGA from 'react-ga4';
import { RouteChangeTracker } from 'shared/components/routerChangeTracker/RouterChangeTracker';
import { useSelector } from 'react-redux';
import { store } from 'shared/redux/configureStore';
import { getReferenceData } from 'plantItemNew/redux/slices/referenceDataSlice';
import PlantDesignRoutes from 'plantDesign/routes/plantDesignRoutes';
import { PaymentCancelCallback } from 'plantItemNew/pages/paymentCallback/PaymentCancelCallback';
import {
  clearPlantItemLicenceTypes,
  getPlantItemLicenceTypes,
} from 'plantItemNew/redux/slices/plantItemLicenceTypesSlice';
import { getPlantDesignLicenceTypes } from 'plantDesign/redux/plantDesignLicenceTypesSlice';
import { getPlantDesignReferenceData } from 'plantDesign/redux/plantDesignReferenceDataSlice';
import PlantItemRenewalRoutes from 'plantItemRenewal/routes/plantItemRenewalRoutes';
import PlantItemNewRoutes from 'plantItemNew/routes/plantItemNewRoutes';
import { LoginRedirect } from 'shared/components/login/LoginRedirect';
import { LoginCallback } from 'shared/components/login/LoginCallback';
import { Logout } from 'shared/components/logout/Logout';
import { Timeout } from 'shared/components/idleTimer/Timeout';

const App = (props) => {
  const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const passwordlessOidc = useSelector((state) => state.passwordlessOidc);

  useEffect(() => {
    if (!passwordlessOidc.user) return;
    // TODO: Load the application related data only.
    loadPlantDesignData();
    loadPlantItemData();
  }, [passwordlessOidc.user]);

  const loadPlantItemData = () => {
    store.dispatch(clearPlantItemLicenceTypes());
    store.dispatch(getPlantItemLicenceTypes());
    store.dispatch(getReferenceData());
  };

  const loadPlantDesignData = () => {
    store.dispatch(getPlantDesignLicenceTypes());
    store.dispatch(getPlantDesignReferenceData());
  };

  useEffect(() => {
    if (process.env.REACT_APP_HOTJAR_ID) {
      hotjar.init(process.env.REACT_APP_HOTJAR_ID);
    }

    if (gaMeasurementId) {
      ReactGA.initialize(gaMeasurementId);
    }
  }, []);

  return (
    <>
      <RouteChangeTracker />
      <CheckApiRequests store={props.store}>
        <Routes>
          <Route path={PagePath.paymentSuccessCallback} element={<PaymentCallback {...props} />} />
          <Route path={PagePath.paymentCancelCallback} element={<PaymentCancelCallback />} />
          <Route path={PagePath.lnswIdpLogin} element={<LoginRedirect />} />
          <Route path={PagePath.lnswIdpLoginCallback} element={<LoginCallback {...props} />} />
          <Route path={PagePath.lnswIdpLogout} element={<Logout {...props} />} />
          <Route path={PagePath.timeout} element={<Timeout {...props} />} />

          {PlantItemNewRoutes(props)}

          {PlantDesignRoutes(props)}

          {PlantItemRenewalRoutes(props)}
        </Routes>
      </CheckApiRequests>
    </>
  );
};

export default App;
